import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { CreateMaintenancePlanDTO } from "../models/MaintenancePlan/CreateMaintenancePlanDTO";
import { EditMaintenancePlanDTO } from "../models/MaintenancePlan/EditMaintenancePlanDTO";
import { GetClientMaintenancePlansResponseDTO } from "../models/MaintenancePlan/GetClientMaintenancePlansResponseDTO";
import { GetMaintenancePlanAuditDTO } from "../models/MaintenancePlan/GetMaintenancePlanAuditDTO";
import { GetMaintenancePlansFromEquipmentRequestDTO } from "../models/MaintenancePlan/GetMaintenancePlansFromEquipmentRequestDTO";
import { MaintenancePlanDTO } from "../models/MaintenancePlan/MaintenancePlanDTO";
import { MaintenancePlanSearchResultDTO } from "../models/MaintenancePlan/MaintenancePlanSearchResultDTO";
import { SearchByBrandDTO } from "../models/MaintenancePlan/SearchByBrandDTO";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";

export class MaintenancePlanService {
    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<MaintenancePlanSearchResultDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/MaintenancePlan/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<MaintenancePlanSearchResultDTO>(
                false,
                "Erro ao ligar ao servidor ao obter a informação dos planos de manutenção",
                "",
                [],
                0,
            );
        }
    }

    async GetById(Id: number | undefined): Promise<MessagingHelper<MaintenancePlanDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/MaintenancePlan/GetById/${Id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor ao obter a informação do plano de manutenção",
                null
            );
        }
    }

    async Create(
        maintenancePlan: CreateMaintenancePlanDTO
    ): Promise<MessagingHelper<number | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/MaintenancePlan/Create`,
                { ...maintenancePlan },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<number | null>(
                false,
                "Erro ao ligar ao servidor para criar o Plano de Manutenção",
                null
            );
        }
    }

    async Edit(
        maintenancePlan: EditMaintenancePlanDTO
    ): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/MaintenancePlan/Edit`,
                { ...maintenancePlan },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para editar o Plano de Manutenção",
                null
            );
        }
    }

    async GetByBrand(
        searchParams: SearchByBrandDTO,
    ): Promise<MessagingHelper<MaintenancePlanDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/MaintenancePlan/GetByBrand`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter os planos de manutenção",
                null
            );
        }
    }

    async Delete(id: Number): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/MaintenancePlan/Delete?id=${id}`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para eliminar o Plano de Manutenção",
                null
            );
        }
    }

    async GetMaintenancePlanAudit(id: Number): Promise<MessagingHelper<GetMaintenancePlanAuditDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/MaintenancePlan/GetMaintenancePlanAudit?id=${id}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<GetMaintenancePlanAuditDTO | null>(
                false,
                "Erro ao ligar ao servidor para obter a auditoria do Plano de Manutenção",
                null
            );
        }
    }

    async DeactivateMaintenancePlan(id: Number): Promise<MessagingHelper<null>> {
        try {
            var response = await APIService.Axios().put(
                `${APIService.GetURL()}/MaintenancePlan/Deactivate?id=${id}`,
                {},
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para inativar o Plano de Manutenção",
                null
            );
        }
    }


    async GetMaintenancePlansFromEquipment(equipmentErpId: string | null | undefined, search: GetMaintenancePlansFromEquipmentRequestDTO): Promise<PaginatedList<GetClientMaintenancePlansResponseDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/MaintenancePlan/GetMaintenancePlansFromEquipment?equipmentErpId=${equipmentErpId}`,
                {
                    ...search,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<GetClientMaintenancePlansResponseDTO>(false, "Ocorreu um erro ao ligar ao servidor para obter os planos de manutenção do equipamento", "", [], 0);
        }
    }
}